export default __webpack_public_path__ + "static/media/noa-9.b9d3ec15.jpg";